<template>
    <div class="slide">
        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question">

                Let’s start with your <span>accounts</span>.

                <div class="description">
                    For now let’s just enter the type of account and the balance. Later, if you would like I would be happy to evaluate your investments and give you my recommendations.
                </div>

            </div>

            <div class="answer answer-col">
                <div class="account-item" v-for="(account, index) in accounts" :key="account.id">

                    <v-btn icon small class="account-delete" @click="deleteAccount(account, index)">
                        <v-icon dark>mdi-delete</v-icon>
                    </v-btn>

                    <div class="row" v-if="personTwoExists">
                        <div class="col-md-12">
                            <v-radio-group v-model="account.individual_id" row>
                                <v-radio label="You" :value="personOne.id"></v-radio>
                                <v-radio :label="personTwo.name" :value="personTwo.id"></v-radio>
                            </v-radio-group>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <v-text-field
                                label="Balance amount $" class="inputNumber" v-model="account.value"
                            ></v-text-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <v-select
                                :items="account_types"
                                label="Type of Account"
                                v-model="account.type_of_account_cd"
                            ></v-select>
                        </div>
                    </div>

                    <div class="form-separator">&nbsp;</div>
                </div>

                <div class="add-new">
                    <v-btn fab small @click="addNewAccount">
                        <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                    Add another account
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    export default {
        name: 'Accounts',
        components: {
            GoBack
        },
        methods: {
            next() {
                this.$store.dispatch('accounts/saveAccounts');
                this.$router.push({ name: 'ThankYou' });
            },
            addNewAccount() {
                let newAccount = {...this.newAccount};
                newAccount.individual_id = this.personOne.id;
                this.$store.commit('accounts/addAccount', newAccount);
            },
            deleteAccount(account, index) {
                this.$store.dispatch('accounts/deleteAccount', { account: account, index: index });
            }
        },
        mounted() {
            this.$store.dispatch('accounts/loadAccounts')
                .then(() => {
                    if (this.accounts.length === 0) {
                        this.addNewAccount();
                    }
                });
        },
        data() {
            return {
                account_types: [
                    {
                        text: 'Basic Checking Accounts',
                        value: 0,
                    },
                    {
                        text: 'Savings Accounts',
                        value: 15,
                    },
                    // {
                    //     text: 'Interest Bearing Checking Accounts',
                    //     value: 0,
                    // },
                    // {
                    //     text: 'Money Market Accounts',
                    //     value: 0,
                    // },
                    {
                        text: 'CD’s',
                        value: 16,
                    },
                    {
                        text: 'IRAs (investment retirement accounts)',
                        value: 3,
                    },
                    // {
                    //     text: 'Brokerage Accounts',
                    //     value: 0,
                    // },
                ],
                newAccount: {
                    id: null,
                    account_number: '',
                    annuity_value: 0,
                    beneficiary_id: null,
                    company_name: '',
                    emergency_funds: 0,
                    has_income_rider: false,
                    individual_id: null,
                    is_annuity: false,
                    notes: '',
                    owner: 0,
                    type_of_account_cd: 0,
                    value: 0,
                },
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
                'personTwoExists',
            ]),
            ...mapGetters('accounts', [
                'accounts'
            ]),
        }
    }
</script>
